// extracted by mini-css-extract-plugin
export default {"inventoryTabs":"Inventory_inventoryTabs__pOxmv","ant-tabs":"Inventory_ant-tabs__HLyMS","ant-tabs-content-holder":"Inventory_ant-tabs-content-holder__Sfwz7"};